

import React, { useState } from 'react';
import './VideoCard.css';
import { useNavigate } from 'react-router-dom';

const VIDEO_BASE_URL = process.env.REACT_APP_VIDEO_BASE_URL;


const VideoCard = ({title, description, videoUrl, locked}) => {
  const navigate = useNavigate();

  const handleProUserPage = () => {
    
      navigate("/subscription");
    
  };

    return (
      <>
        <article className={`video-card pt-2 ${locked ? "is-locked" : ""}`}>
          <div className="media-box">
            {locked ? (
              <>
                <div className="lock-overlay" onClick={handleProUserPage}>
                  <span className="lock-icon">🔒</span>
                  <span className="lock-text">Get Pro</span>
                </div>
              </>
            ) : (
              <iframe
                className="media"
                src={`${VIDEO_BASE_URL}${videoUrl}`}
                title={title}
                frameBorder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen="true"
                referrerPolicy="unsafe-url"
              />
            )}
          </div>
          <div className="video-info">
            <h3 className="video-title">{title}</h3>
            <p className="video-description">{description}</p>
          </div>
        </article>

      </>
    );
};

export default VideoCard;
